module.exports = __webpack_public_path__ + "media/images/pages/sign-in-bg-1dbeba2b6ce1d0003f938e161d542652.png";